import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

export type CheckboxSize = 'sm' | 'lg';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  standalone: true,
  imports: [NgClass],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxInputComponent implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  @Input() controlId: string | null = null;
  @Input() size: CheckboxSize = 'sm';

  @Output() checkboxClicked = new EventEmitter<void>();

  public generatedRandomId = `checkbox-${Math.random().toString(36).slice(2)}`;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};
  public disabled: boolean = false;

  isChecked: boolean = false;

  public writeValue(value: boolean): void {
    this.isChecked = value;
    this.cdr.markForCheck();
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  public toggleCheckbox(): void {
    this.isChecked = !this.isChecked;
    this.onChange(this.isChecked);
    this.onTouched();
    this.checkboxClicked.emit();
  }
}
